/* eslint-disable import/prefer-default-export */
import axios from 'axios';

export const handleSendTech = async (payload) => {
  const response = await axios.post(
    '/.netlify/functions/create-booking',
    payload,
  );
  return { status: response.status, data: response.data };
};
